import React, { useState, useEffect, useRef } from 'react';
import '../../../../css/qualifier.css';
import ReccomendationBlock from '../../../reccomendation/reccomendationBlock';
import ExtraInfo from '../../../reccomendation/extraInfo';
import { determineHealthRating, tobaccoRatings, nonTobaccoRatings } from '../../../../utilities/virtualMentor';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { removeReccomendations, updateReccomendation } from '../../../../features/productRecommendationSlice';
import { getQuotesForProducts } from '../../../../utilities/virtualMentor';
import '../../../../css/loading.css'
import Icon from '../../../../assets/icons/icon';
import { useDebouncedCallback } from 'use-debounce';

function Recommendation({ selectedTab, handleSelectedTab, selectedProducts, setSelectedProducts, handleProfileUpdate,setFaceAmount,faceAmount,term,setTerm, profile, possibleConditions,setHealthRating}) {
    const [extraInfo, setExtraInfo] = useState(false);
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const dispatch = useDispatch()
    const [recHealthRating, setRecHealthRating] = useState('SP')
    const [recPlanType, setRecPlanType] = useState('');
    const [recFaceAmount, setRecFaceAmount] = useState(0)

    const agentInfo = useSelector((state) => state.agent.userData)

    const closePopup=()=>{
        setExtraInfo(false);
    }
    const handleTermChange=(event)=>{
        setTerm(event.target.value)
        handleProfileUpdate('term',event.target.value);
    }
    const handleFaceChange=(value)=>{
        setFaceAmount(value)
        //handleProfileUpdate('faceAmount',value);
    }
    const handleSetFaceAmount=(value)=>{
        if(faceAmount !== recFaceAmount){
            handleProfileUpdate('faceAmount',value)
            setRecFaceAmount(value)
        }
    }

    const handleHealthRating=(event)=>{
        let selectedRating = event.target.value

        updateHealthRating(selectedRating)
    }

    const updateHealthRating = (selectedRating) => {
        // let suffix = 'NT'
        setRecHealthRating(selectedRating)

        const rating = determineHealthRating(profile.tobacco, selectedRating, selectedTab)

        handleProfileUpdate('healthRating', rating)
        setHealthRating(rating)
    }
    const handlePlanType=(event)=>{
        setRecPlanType(event.target.value)
        //handleProfileUpdate('healthRating', calculatedHealthRating)
    }

    const healthRef = useRef()

    const tobaccoPlanTypes = [
        {
            Label: 'Choose Type',
            Vaule: '',
        },
        {
            Label: 'Level',
            Vaule: 'level',
        },
        {
            Label: 'Graded',
            Vaule: 'graded',
        },
    ]

    const nonTobaccoPlanTypes = [
        {
            Label: 'Choose Type',
            Vaule: '',
        },
        {
            Label: 'Level',
            Vaule: 'level',
        },
        {
            Label: 'Level Preferred',
            Vaule: 'level pre',
        },
        {
            Label: 'Graded',
            Vaule: 'graded',
        },
    ]

    const [planTypeOptions, setPlanTypeOptions] = useState(profile.tobacco === 'no' ? nonTobaccoPlanTypes : tobaccoPlanTypes);
    useEffect(() => {
        if(selectedTab==='term'){
            if(faceAmount !=='100000'){
                handleFaceChange('100000')
                handleSetFaceAmount('100000')
            }
        }
        else if(selectedTab==='whole'){
            if(faceAmount !=='25000' && faceAmount >= '100000'){
                handleFaceChange('25000')
                handleSetFaceAmount('25000')
            }
        }
    }, [selectedTab]);

    useEffect(() => {
        // check and see if the profile health rating needs to be updated
        if(selectedTab==='term' && healthRef.current !== null && ((profile.tobacco === 'yes' && !tobaccoRatings.includes(profile.healthRating)) || (profile.tobacco !== 'yes' && !nonTobaccoRatings.includes(profile.healthRating)))){
            updateHealthRating(healthRef.current.value)
        } else if(selectedTab==='whole'){
            if(leadsAlldata.tobacco === 'no'){
                setPlanTypeOptions(nonTobaccoPlanTypes)

                if(recPlanType == 'level pre'){
                    updateHealthRating('PP')
                } else {
                    updateHealthRating('S')
                }
            } else {
                setPlanTypeOptions(tobaccoPlanTypes)

                if(recPlanType === 'level pre'){
                    setRecPlanType('')
                }

                updateHealthRating('S')
            }
        }
     }, [leadsAlldata.lead_id,leadsAlldata.tobacco])

    useEffect(() => {
        if(selectedTab==='whole'){
            if(recPlanType == 'level pre' && leadsAlldata.tobacco === 'no'){
                updateHealthRating('PP')
            } else {
                updateHealthRating('S')
            }
        }
    }, [recPlanType])

    const products = useSelector(state => state.productRecommendations.products)
    const reccomendations = useSelector(state => state.productRecommendations.reccomendations)

    let incrementValue = 5
    const parsedIncrementValue = parseInt(process.env.REACT_APP_QUOTE_INCREMENT)

    if(!isNaN(parsedIncrementValue)){
        incrementValue = parsedIncrementValue
    }

    const [missingFields,setMissingFields] = useState({
        faceAmount: false,
        state: false,
        dobORage: false,
        // sex: false,
        tobacco: false,
        products: false,
    })

    const [quoteError, setQuoteError] = useState(false)

    const getQuote = async (start, stop) => {
        try {
            const productSlice = products.slice(start, stop)
            const newQuotes = await getQuotesForProducts(productSlice, profile, agentInfo.agentId)
            const updatedRecs = []
            const removeRecs = []

            for (let index = 0; index < productSlice.length; index++) {
                const product = productSlice[index];
                const rec = reccomendations.find(r => r.uid === product.uid)
                const quote = newQuotes.find(q => q.ProductUID === rec.uid && q.NoPremium === false)

                if(!rec){
                    continue
                }

                if(quote){
                    updatedRecs.push({
                        ...rec,
                        quote
                    })
                } else {
                    removeRecs.push(product.uid)
                }
            }

            for (let index = 0; index < updatedRecs.length; index++) {
                const reccomendation = updatedRecs[index];
                dispatch(updateReccomendation({reccomendation}))
            }

            if(removeRecs.length > 0){
                dispatch(removeReccomendations({removeUIDs: removeRecs}))
            }
        } catch (error) {
            console.debug(error)
        }
    }

    const runVMWaitTime = process.env.REACT_APP_DEBOUNCE_WAIT || 3000

    let quoteRequest = []
    const debouncedQuoteRequest = useDebouncedCallback(async () => {
        let start = 0
        let stop = incrementValue

        const requiredMissingFields = {
            faceAmount: !!!profile.faceAmount,
            state: !!!profile.state,
            dobORage: (!!!profile.borrower_age && !!!(new Date(profile.borrower_dob)).getDate()),
            // sex: !!!profile.borrower_sex,
            tobacco: !!!profile.tobacco,
        }

        setMissingFields(requiredMissingFields)

        for (const key in requiredMissingFields) {
            if(requiredMissingFields[key] === true){
                setQuoteError(true)
                return
            }
        }

        setQuoteError(false)

        while (true) {
            quoteRequest.push(getQuote(start, stop))

            start = stop
            stop = stop + incrementValue

            if(start >= products.length){
                break
            }
        }

        Promise.all(quoteRequest)
    }, runVMWaitTime)

    useEffect(()=> {
        // existing http quote request will be canceled in runVM method.
        // The logic in this is if statement cancels the pending deboucned
        // method above that iniates more quote request.
        if(debouncedQuoteRequest.isPending()){
            debouncedQuoteRequest.cancel()
        }

        debouncedQuoteRequest()
    }, [products.length > 0, profile])

    return (
        <div className='recWrapper'>
            <div className="productTabs">
                <div className={`productTab ${selectedTab==='term' ? 'selectedTab':''}`} onClick={()=>handleSelectedTab('term')}>Term Products</div>
                <div className={`productTab ${selectedTab==='whole' ? 'selectedTab':''}`} onClick={()=>handleSelectedTab('whole')}>Whole Life</div>
            </div>
            <div className="recOptions">

                <div className="recInputHolder">
                    <div className="recInputTitle">
                        Face Amount
                    </div>
                    <input type="text" className="recInput" onChange={(e)=>handleFaceChange(e.target.value)} value={faceAmount} onBlur={(e)=>handleSetFaceAmount(e.target.value)}/>
                </div>
                {selectedTab==='term' && (
                    <div className="recInputHolder">
                        <div className="recInputTitle">
                            Term Length
                        </div>
                        <select className="recInputSelect" onChange={handleTermChange} value={term}>
                            <option value="10">10 Year</option>
                            <option value="15">15 Year</option>
                            <option value="20">20 Year</option>
                            <option value="25">25 Year</option>
                            <option value="30">30 Year</option>
                            <option value="35">35 Year</option>
                            <option value="40">40 Year</option>
                        </select>
                    </div>
                )}
                {selectedTab==='term' ? (
                    <div className="recInputHolder">
                        <div className="recInputTitle">
                            Rate Class
                        </div>
                        <select className="recInputSelect" onChange={handleHealthRating} value={recHealthRating} ref={healthRef}>
                            <option value="PP">Preferred Plus</option>
                            <option value="P">Preferred</option>
                            <option value="SP">Standard Plus</option>
                            <option value="S">Standard</option>
                        </select>
                    </div>
                ) : (
                    <div className="recInputHolder">
                        <div className="recInputTitle">
                            Plan Type
                        </div>
                        <select className="recInputSelect" onChange={handlePlanType} value={recPlanType}>
                            {planTypeOptions.map(({Label, Vaule}, index)=> (
                                <option value={Vaule} key={`planTypeOption${index}`}>{Label}</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
            <div className="recResults">
                {(reccomendations.length === 0 && quoteError === false) && (
                    <div className='loadingWrapper'>
                        <div className='loading_bar'></div>
                    </div>
                )}

                {quoteError && (
                    <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: '8px', width: '96%', margin: '0 auto'}}>
                        {missingFields.faceAmount && (
                            <div style={{ alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #FDA29B solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                                </div>
                                <div>A face amount is needed in order to provide a quote.</div>
                            </div>
                        )}
                        {missingFields.state && (
                            <div style={{ alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #FDA29B solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                                </div>
                                <div>{leadsAlldata.borrower_first}'s state is needed in order to provide a quote.</div>
                            </div>
                        )}
                        {missingFields.dobORage && (
                            <div style={{ alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #FDA29B solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                                </div>
                                <div>{leadsAlldata.borrower_first}'s age and/or date of birth is needed in order to provide a quote.</div>
                            </div>
                        )}
                        {/* {missingFields.sex && (
                            <div style={{ alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #FDA29B solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                                </div>
                                <div>{leadsAlldata.borrower_first}'s sex is needed in order to provide a quote.</div>
                            </div>
                        )} */}
                        {missingFields.tobacco && (
                            <div style={{ alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #FDA29B solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                                </div>
                                <div>{leadsAlldata.borrower_first}'s tobacco use is needed in order to provide a quote.</div>
                            </div>
                        )}
                    </div>
                )}

                {(reccomendations && quoteError === false) && reccomendations.map((result, index) => (
                    selectedTab==='whole' ? (
                        recPlanType==='' ? (
                            <ReccomendationBlock position={index+1} key={`recc2${index}`} faceAmount={faceAmount} possibleConditions={possibleConditions} selectedProducts={selectedProducts} reccomendation={result} setSelectedProducts={setSelectedProducts} setExtraInfo={setExtraInfo}/>
                        ) : recPlanType==='graded' && result.plan_type==='graded' ? (
                            <ReccomendationBlock position={index+1} key={`recc2${index}`} faceAmount={faceAmount} possibleConditions={possibleConditions} selectedProducts={selectedProducts} reccomendation={result} setSelectedProducts={setSelectedProducts} setExtraInfo={setExtraInfo}/>
                        ) : recPlanType==='level' && result.plan_type==='level' ? (
                            <ReccomendationBlock position={index+1} key={`recc2${index}`} faceAmount={faceAmount} possibleConditions={possibleConditions} selectedProducts={selectedProducts} reccomendation={result} setSelectedProducts={setSelectedProducts} setExtraInfo={setExtraInfo}/>
                        ) : recPlanType==='level pre' && result.plan_type==='level pre' && (
                            <ReccomendationBlock position={index+1} key={`recc2${index}`} faceAmount={faceAmount} possibleConditions={possibleConditions} selectedProducts={selectedProducts} reccomendation={result} setSelectedProducts={setSelectedProducts} setExtraInfo={setExtraInfo}/>
                        )
                    ) : (
                        (!result.plan_type || parseInt(result.plan_type) === parseInt(term)) && (
                            <ReccomendationBlock position={index+1} key={`recc2${index}`} faceAmount={faceAmount} possibleConditions={possibleConditions} selectedProducts={selectedProducts} reccomendation={result} setSelectedProducts={setSelectedProducts} setExtraInfo={setExtraInfo}/>
                        )
                    )
                ))}
            </div>
            {extraInfo && (
                <ExtraInfo extraInfo={extraInfo} closePopup={closePopup} />
            )}
        </div>
    );

}

export default Recommendation;

